import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { BenefitPlanFundingSourceAndSchedule } from '@models/configuration/model';

export type BenefitPlanFundingSourceAndScheduleState = EntityState<BenefitPlanFundingSourceAndSchedule, string>

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'BenefitPlanFundingSourceAndSchedule' })
export class BenefitPlanFundingSourceAndScheduleStore extends EntityStore<BenefitPlanFundingSourceAndScheduleState> {
  constructor() {
    super();
  }
}
